
const $ = require('jquery');


function PromiseQueue () {
	if (!(this instanceof PromiseQueue)) {
		return new PromiseQueue();
	}

	this._queue = [];
	this._running = false;

	return this;
}

PromiseQueue.prototype = {
	enqueue: function (taskFunction) {
		/*
		 * Adds a task to the queue. If the queue is empty, task will be
		 * called immediately, otherwise the task will be called once
		 * all the tasks before it end (resolved or rejected)
		 *
		 * `taskFunction` must return a promise.
		 *
		 * Returns a promise which
		 *  * will be resolved when the `taskFunction`'s promise is
		 *	resolved or rejected
		 */
		const oldLength = this._queue.length;

		const dfr = $.Deferred();
		this._queue.unshift({
			task: taskFunction,
			dfr: dfr,
		});

		if (!oldLength && !this._running) {
			this._dequeue();
		}

		return dfr.promise();
	},

	_dequeue: function () {
		if (this._running) {
			return;
		}

		const self = this;

		const next = self._queue.shift();
		if (next) {
			self._running = next.task().promise();
			self._running.always(function (value) {
				next.dfr.resolve(value);

				self._running = false;
				self._dequeue();
			});
		}
	},

	isEmpty: function () {
		return !this._queue.length;
	},

	isRunning: function () {
		return Boolean(this._running);
	},

	getRunning: function () {
		return this._running;
	},
};

module.exports = PromiseQueue;

